module.exports = __webpack_public_path__ + "static/who-we-are-and-how-we-got-here-f27ed72fd102f581e2c14bef439a2b05.jpg";